import {Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import React from 'react';
import {StyledButton} from './styles';
import {QuickActionProps} from './types';

export function QuickAction({iconName, label, onClick}: QuickActionProps) {
	const theme = useTheme();
	return (
		<Stack sx={{width: '100%'}}>
			<StyledButton onClick={onClick}>
				<Icon name={iconName} color={theme.palette.primary.main} />
				<Typography variant="caption" lineHeight="160%">
					{label}
				</Typography>
			</StyledButton>
		</Stack>
	);
}
